var FcYearMonthInputModule = /** @class */ (function () {
    function FcYearMonthInputModule() {
    }
    return FcYearMonthInputModule;
}());
export { FcYearMonthInputModule };
